import { reportError } from '@mobi/utils'
import { isPaymentProcessorErrorCode } from '../Areas/Deposit/Utils/errorCodes'

type Params = {
  errorCode?: string
  message: string
}

export function reportErrorIfNeeded({ errorCode, message }: Params) {
  if (!errorCode || (errorCode !== 'validation_error' && !isPaymentProcessorErrorCode(errorCode))) {
    reportError('deposit', message)
  }
}
